import fetch from 'cross-fetch';
import get from 'lodash/get';
import {ApiV1Base, ApiPrefix, statusCheck, json, getCookie } from '../util/icwUtility';

export const COUNTRY_LIST_FETCH_BEGIN = 'COUNTRY_LIST_FETCH_BEGIN';
function actCountryListFetchBegin() {
  return { type: COUNTRY_LIST_FETCH_BEGIN };
}

export const COUNTRY_LIST_FETCH_SUCCESS = 'COUNTRY_LIST_FETCH_SUCCESS';
export function actCountryListFetchSuccess(data) {
  return { type: COUNTRY_LIST_FETCH_SUCCESS, payload: data };
}

export const COUNTRY_LIST_FETCH_FAIL = 'COUNTRY_LIST_FETCH_FAIL';
function actCountryListFetchFail(reason) {
  return { type: COUNTRY_LIST_FETCH_FAIL, payload: reason };
}

export function actCountryListFetch(type = 'testItem', isTestPlanUse = true) {
  // testItem || iSource
  // isTestPlanUse: true || false
  return (dispatch) => {
    dispatch(actCountryListFetchBegin());
    return fetch(`${ApiV1Base}${ApiPrefix}/countryList?type=${type}&isTestPlanUse=${isTestPlanUse}`, {
      headers: { Authorization: getCookie('token') },
    })
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const data = get(res, 'data', []);
        dispatch(actCountryListFetchSuccess(data));
      })
      .catch((err) => {
        dispatch(actCountryListFetchFail(typeof err === 'object' ? err.message : err));
      });
  };
}
